import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';
import { BusinessIDVSettings } from '@models/businessSettings/settings';
import { IDVProvider } from '@models/idv';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';
import { UrlService } from '@services/url/url.service';
import { BusinessDispatch, BusinessState } from '@state/business';
import { BusinessUsersDispatch } from '@state/business-users/business-users.dispatch';

export interface TreefortOnboardingModalData {
	primaryButtonText?: string;
}

@Component({
	selector: 'app-treefort-onboarding-modal',
	templateUrl: './treefort-onboarding-modal.component.html',
	standalone: false,
})
export class TreefortOnboardingModalComponent implements OnInit {
	@SelectSnapshot(BusinessState.getTreefortConnected)
	treefortConnected: boolean;
	public primaryButtonText: string;
	public businessSettingsUrl = UrlService.Manage_Finances_General();
	public ICON = ICON;
	public treefortUrl = 'https://treeforttech.com/user-license-agreement/';
	public idvSettingsUrl = UrlService.Manage_Finances_General();

	constructor(
		private dialogRef: MatDialogRef<TreefortOnboardingModalComponent>,
		private businessDispatch: BusinessDispatch,
		private businessUsersDispatch: BusinessUsersDispatch,
		private analytics: AnalyticsService,
		@Inject(MAT_DIALOG_DATA) public data: TreefortOnboardingModalData,
	) {}

	ngOnInit(): void {
		this.primaryButtonText = this.data?.primaryButtonText || 'Start IDV';
	}

	public closeButtonClick(): void {
		this.closeModal();
	}

	public startIDVClick(): void {
		if (!this.treefortConnected) {
			this.analytics.logEvent(AnalyticsEvent.TREEFORT_INTEGRATIONS_CONNECT);
			this.businessDispatch.UpdateDefaultSettings({
				idv: { defaultProvider: IDVProvider.TREEFORT } as BusinessIDVSettings,
			});
		}
		this.closeModal(true);
	}

	public closeModal(shouldOpenIDVModal: boolean = false) {
		this.dialogRef.close(shouldOpenIDVModal);
	}
}
